import { IEntityType } from "@/models";

import { BaseRepository } from "@/repositories";

class EntityTypeRepository extends BaseRepository<IEntityType> {
    constructor() {
        super("/entity-types");
    }
}

const entityTypeRepository = new EntityTypeRepository();

export { EntityTypeRepository, entityTypeRepository };
